import React from 'react'
import ChooseYourPlan from '../../pages/ChooseYourPlan'

function Planbill() {
  return (
    <div className='w-full bg-[#5178af] mx-auto'>
  <ChooseYourPlan/>
    </div>
  )
}

export default Planbill